module.exports = __webpack_public_path__ + "static/media/housing.bc7010bf.png";